import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class TabelasPrecoItensService extends BaseService {

    constructor(private http: HttpClient) { super(); }

    getTabelasPrecoItemRepresentante(itemId: number, representanteId: number) {
        return this.http
            .get(`${this.UrlService}TabelasPrecoItens/GetTabelasPrecoItemRepresentante?itemId=${itemId}&representanteId=${representanteId}`)
            .pipe(map((res: any) => res.data)
                , catchError(super.serviceError));
    }

    salvar(itens: any) {
        return this.http
            .post(`${this.UrlService}TabelasPrecoItens/Salvar`, itens)
            .pipe(map((res: any) => res.data)
                , catchError(super.serviceError));
    }
}
